import { useQuery } from '@tanstack/react-query';
import { summaryApis } from './api';

/** GET /users/me - returns { firstName, lastName, fullName, phone, email } */
const useGetMe = ({ enabled = true } = {}) => {
  const queryResult = useQuery({
    queryKey: ['users', 'me'],
    queryFn: () => summaryApis.getMe(),
    enabled,
  });
  return queryResult;
};
const useGetClinic = ({ userType, enabled = true } = {}) => {
  const queryResult = useQuery({
    queryKey: ['get-clinic', userType],
    queryFn: () => summaryApis.getClinics(userType),
    enabled,
  });
  return queryResult;
};
export const useSummaryQueries = { useGetMe, useGetClinic };
